import React from 'react';
import { PageBaseComponent } from "../../../library/cms/page-components";
import EditIcon from "../../../library/cms/edit-icon";
import { MediaManagerController } from "../../../library/cms/media-manager";
import InfoIcon from "../../../library/cms/info-icon";
import JsUtility from "../../../library/utils/utility";

export class FadeCarouselComponent extends PageBaseComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onFilesSelected(files) {
        this.state.component.content.media = files;
        this.setState(this.state.component);
    }

    onFilesCancel() {}

    onEditClick(event) {
        this.mediaController.mode = 'multi-select';
        this.mediaController.show(this.state.component.content.media);
    }

    render() {
        var media = this.state.component.content.media;
        let mediaWidth = 640;
        if (this.props.mediaWidth) {
            mediaWidth = parseInt(this.props.mediaWidth);
        }
        let minWidth = mediaWidth + 1;
        var cls = this.props.cssClass || 'hero-carousel';
        this.updateMediaUrls(this.props.mediaManagerData);

        var nodes = media.map((file, index) => {
            var src = file.url;
            var mobileSrc = JsUtility.toMobileUrl(src);
            return (
                <carousel-item key={index}>
                    <picture>
                        <source media={`(min-width: ${minWidth}px)`} srcSet={src} />
                        <source media={`(max-width: ${mediaWidth}px)`} srcSet={mobileSrc} />
                        <img src={src} />
                    </picture>
                </carousel-item>
            );
        });

        return (
            <div className="relative">
                <ui-carousel animation="fade" class={cls} cross-fade="true">
                    {nodes}
                </ui-carousel>
                <EditIcon onClick={this.onEditClick.bind(this)} active={this.state.component.active}>
                    <MediaManagerController
                        postUrl='/api/MediaFile'
                        data={this.props.mediaManagerData}
                        ref={(ref) => this.mediaController = ref}
                        onFilesSelected={this.onFilesSelected.bind(this)}
                        onCancel={this.onFilesCancel.bind(this)}
                    />
                </EditIcon>
                {this.props.instructions && <InfoIcon content={this.props.instructions} active={this.state.component.active} cls={this.props.secondaryIconCss} header={this.props.infoHeader} />}
            </div>
        );
    }
}

export default FadeCarouselComponent;
